export default __webpack_public_path__ + "static/media/badge.bd4a042f.svg";